import {memo} from "react";
import {Button, FormGroup, TextField} from "@mui/material";
import {styled} from "@mui/system";

// Поле диапазона "[от, до)" — кнопки-скобки переключают включение границы.
const RangeField = styled(TextField)({width: '40%'});
// lineHeight 1 и без вертикальных отступов: высоту задаёт поле ввода (кнопка растягивается по строке),
// иначе в компактной теме скобки выше полей
const Bracket = styled(Button)({minWidth: '10%', textTransform: 'lowercase', fontSize: 22, lineHeight: 1, paddingTop: 0, paddingBottom: 0});

const isIncluded = (value) => value || value === null;
const text = (value) => value !== undefined && value !== null ? value : '';

function AudienceRangeInput({parameterSet, error, onChange}) {
    const fromIncluded = isIncluded(parameterSet.fromIncl);
    const toIncluded = isIncluded(parameterSet.toIncl);
    return (
        <FormGroup row sx={{flexWrap: 'nowrap', alignItems: 'stretch'}}>
            <Bracket
                variant="contained"
                disableElevation
                sx={{borderTopRightRadius: 0, borderBottomRightRadius: 0}}
                onClick={() => onChange('fromIncl', !fromIncluded)}
            >
                {fromIncluded ? '[' : '('}
            </Bracket>
            <RangeField
                placeholder='∞'
                value={text(parameterSet.paramFromValue)}
                error={error}
                sx={{'& fieldset': {borderRadius: 0}}}
                onChange={(e) => onChange('paramFromValue', e.target.value)}
            />
            <RangeField
                placeholder='∞'
                value={text(parameterSet.paramToValue)}
                error={error}
                sx={{'& fieldset': {borderRadius: 0}}}
                onChange={(e) => onChange('paramToValue', e.target.value)}
            />
            <Bracket
                variant="contained"
                disableElevation
                sx={{borderTopLeftRadius: 0, borderBottomLeftRadius: 0}}
                onClick={() => onChange('toIncl', !toIncluded)}
            >
                {toIncluded ? ']' : ')'}
            </Bracket>
        </FormGroup>
    );
}

export default memo(AudienceRangeInput);
